import { Component, Inject } from '@angular/core';
import { envSettings } from '@ami/angular/core/env-settings';
import { AMI_SITE_TYPE } from '../ami-environments/ami-site-type-injection-token';
import { AmiSiteType } from '../ami-environments/ami-site-type.enum';

@Component({
  selector: 'ami-version-page',
  standalone: true,
  template: `
    <div style="font-family: monospace; padding: 2rem;">
      <h1>{{ appName }}</h1>
      <p>version: <strong>{{ version }}</strong></p>
    </div>
  `,
})
export class VersionPageComponent {
  appName: string;
  version: string;

  constructor(@Inject(AMI_SITE_TYPE) siteType: AmiSiteType) {
    this.appName = AmiSiteType[siteType];
    this.version = envSettings('NX_REACT_APP_AMI_VERSION', { optional: true }) ?? 'unknown';
  }
}
